import { CloseIcon } from "@chakra-ui/icons";
import { HStack, Button, IconButton } from "@chakra-ui/react";
import { DataSourceWithNetworks } from "@syla/shared/types/responses/DataSourceWithNetworks";

import React from "react";
import { DataSourceInputType } from "../../../../helper/dataSource/DataSourceInputType";
import { DataSourceDrawerFooter } from "../components/DataSourceDrawerFooter";
import { DataSourceDrawHeader } from "../components/DataSourceDrawerHeader";
import { DataSourceTitle } from "../components/DataSourceTitle";
import { ImportProgressStatus } from "../components/ImportProgressStatus";
import { isCompleted } from "../helpers/isCompleted";
import { ImportStage } from "../workflows/ImportStage";
import { ImportMethod } from "./ImportMethodSelectionPanel";

export function ImportProgressPanel({
  dataSource,
  importStage,
  importMethod,
  customName,
  onComplete,
}: {
  dataSource: DataSourceWithNetworks;
  importStage: Extract<
    ImportStage,
    "initialising" | "importing" | "backgroundImporting" | "complete"
  >;
  importMethod: ImportMethod;
  customName: string;
  onComplete: () => void;
}): React.ReactElement {
  const isImportComplete = isCompleted(importStage);

  return (
    <>
      <DataSourceDrawHeader>
        <HStack justify={isImportComplete ? undefined : "flex-end"} w="full">
          <DataSourceTitle name={customName} image={dataSource.image} />
        </HStack>

        {isImportComplete && (
          <IconButton
            aria-label="Close"
            boxSize="2.5rem"
            fontSize="md"
            variant="ghost"
            colorScheme="gray"
            icon={<CloseIcon />}
            onClick={onComplete}
          />
        )}
      </DataSourceDrawHeader>

      <ImportProgressStatus
        dataSource={dataSource}
        stage={importStage}
        importMethod={importMethod}
      />

      <DataSourceDrawerFooter>
        {!isImportComplete && (
          <Button
            variant="solid"
            colorScheme="primary"
            disabled={true} // always disabled, the button is just to show in-progress
          >
            {importMethod === DataSourceInputType.Api ? "Syncing" : "Importing"}
          </Button>
        )}
        {isImportComplete && (
          <Button
            variant="solid"
            colorScheme="gray"
            onClick={() => {
              onComplete();
            }}
          >
            Continue
          </Button>
        )}
      </DataSourceDrawerFooter>
    </>
  );
}
